import React, { useEffect, useMemo, useState } from 'react';

import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button, Col, Row, Tooltip } from 'antd';
import CustomTable from '../../components/CustomTable/CustomTable';
import CustomSearchInput from '../../components/CustomSearchInput/CustomSearchInput';

import { ReactComponent as Filter } from '../../assets/filter-icon.svg';
import { ReactComponent as Pluse } from '../../assets/pluse-litl-icon.svg';
import { ReactComponent as Delete } from '../../assets/delete-black-icon.svg';
import { ReactComponent as Download } from '../../assets/export-icon.svg';
import { ReactComponent as Eye } from '../../assets/eye-icon.svg';
import { ReactComponent as Cancel } from '../../assets/cancel-icon-min.svg';
import { ReactComponent as Report } from './img/report-icon.svg';
// import { ReactComponent as Download } from '../../assets/export-icon.svg';
import { textSort } from '../../helpers/textSort';
import CustomSortIcon from '../../components/CustomSortIcon/CustomSortIcon';
import ModalOnboarding from '../../components/ModalOnboarding/ModalOnboarding';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearOnboardingSubmission,
  getOnboardingAll,
  getOnboardingForms,
} from '../../data/store/onboarding/onboardingActions';
import dayjs from 'dayjs';
import ModalDeleteOnboarding from './ModalDeleteOnboarding/ModalDeleteOnboarding';
import ModalFilterAdvise from './ModalFilterAdvise';
import OnboardingFileViewer from './OnboardingFileViewer/OnboardingFileViewer';
import api from '../../utils/API';

const Onboarding = ({ userId }) => {
  const { t } = useTranslation('');
  const history = useHistory();
  const dispatch = useDispatch();
  const [filter, setFilter] = useState(null);

  // eslint-disable-next-line no-unused-vars
  const { onboardingList, onboardingForms, isLoading } = useSelector(
    (state) => state.onboardingReducer,
  );

  const loading = useMemo(() => !onboardingList && isLoading, [onboardingList, isLoading]);
  
  const { list: accountList } = useSelector(
    (state) => state.accountReducer.accounts,
  );

  const [filteredIOnboarding, setFilteredIOnboarding] = useState([]);
  const [search, setSearch] = useState('');
  const [openFilter, setOpenFilter] = useState(null);
  const [openStart, setOpenStart] = useState(false);
  const [deleteModal, setDeleteModal] = useState(null);
  const [previewData, setPreviewData] = useState(null);

  useEffect(() => {
    console.log('🚀 ~ Onboarding ~ filter:', filter);
  }, [filter]);
  

  useEffect(() => {
    dispatch(getOnboardingForms());
    dispatch(getOnboardingAll(userId));
    const interval = setInterval(() => {
      dispatch(getOnboardingAll(userId));
    }, 5000);
    return () => {
      clearInterval(interval);
      dispatch(clearOnboardingSubmission());
    };
  }, []);

  // useEffect(() => {
  //   if (onboardingList?.length) {
  //     setFilteredIOnboarding(onboardingList);
  //   } else {
  //     setFilteredIOnboarding([]);
  //   }
  // }, [onboardingList]);

  const handleCreate = () => {
    setOpenStart(true);
  };

  const handleView = (submissionId, formId) => {
    history.push(
      `/onboarding/edit/${submissionId}?account-id=${userId}&form-id=${formId}`,
    );
  };

  const handleViewReport = async (id) => {
    const getDocument = async () => {
      try {
        const response = await api.get(`/v3/bff/form-submission/${id}`);
        return response?.data?.submitted_document ?? null;
      } catch (error) {
        console.log('🚀 ~ getDocument ~ error:', error);
        return null;
      }
    };

    const document = await getDocument();
    if (document) {
      const { data, mime_type, name } = document;
      setPreviewData({ data, mime_type, name });
    }
  };

  const hendleDownload = async (id) => {
    try {
      const response = await api.get(`/v3/bff/form-submission/${id}`);
      const submittedDoc = response?.data?.submitted_document ?? null;
      if (!submittedDoc?.data) return;

      const { data: base64Data, mime_type: mimeType, name } = submittedDoc;
      const binaryString = atob(base64Data);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i += 1) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const blob = new Blob([bytes], {
        type: mimeType || 'application/octet-stream',
      });
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = name || 'document';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.log('🚀 ~ hendleDownload ~ error:', error);
    }
  };

  const handleCloseViewReport = () => {
    setPreviewData(null);
  };

  const handleDeleteForm = (id, status) => {
    setDeleteModal({ id, cancel: isCancelButton(status) });
  };

  useEffect(() => {
    const list = onboardingList ?? [];

    const getFormName = (formId) =>
      onboardingForms?.find((form) => form.id === formId)?.name ?? '';

    const normalizedSearch = (search ?? '').trim().toLowerCase();
    const searchActive = normalizedSearch.length > 2;

    let selectedDocTypes = [];
    let docTypeFilterActive = false;
    if (filter?.documentType && !filter.documentType.ALL) {
      selectedDocTypes = Object.entries(filter.documentType)
        .filter(([key, checked]) => key !== 'ALL' && checked)
        .map(([key]) => key);
      docTypeFilterActive = selectedDocTypes.length > 0;
    }

    let selectedStatuses = [];
    let statusFilterActive = false;
    if (filter?.status && !filter.status.ALL) {
      selectedStatuses = Object.entries(filter.status)
        .filter(([key, checked]) => key !== 'ALL' && checked)
        .map(([key]) => key);
      statusFilterActive = selectedStatuses.length > 0;
    }

    const startD =
      filter?.start && dayjs(filter.start).isValid()
        ? dayjs(filter.start).startOf('day')
        : null;
    const endD =
      filter?.end && dayjs(filter.end).isValid()
        ? dayjs(filter.end).startOf('day')
        : null;

    const matchesDate = (item) => {
      if (!startD && !endD) return true;
      const itemDate = dayjs(item.updated_at).startOf('day');
      if (!itemDate.isValid()) return false;
      if (!startD && endD) {
        return !itemDate.isAfter(endD, 'day');
      }
      if (startD && !endD) {
        return !itemDate.isBefore(startD, 'day');
      }
      return (
        !itemDate.isBefore(startD, 'day') && !itemDate.isAfter(endD, 'day')
      );
    };

    const next = list.filter((item) => {
      const formName = getFormName(item.form_id);
      if (searchActive) {
        const hay = formName.toLowerCase();
        if (!hay.includes(normalizedSearch)) return false;
      }
      if (docTypeFilterActive && !selectedDocTypes.includes(formName)) {
        return false;
      }
      if (statusFilterActive && !selectedStatuses.includes(item.status)) {
        return false;
      }
      if (!matchesDate(item)) return false;
      return true;
    });

    setFilteredIOnboarding(next);
  }, [search, onboardingList, filter, onboardingForms]);
  

  const handleSearch = (event) => {
    const { value } = event.target;
    setSearch(value);
  };

  const handeleFilter = () => {
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  const handleClose = () => {
    setOpenStart(false);
  };

  const getStatus = (value) => {
    switch (value) {
      case 'Available':
        return (
          <div className="onboarding-tag  onboarding-tag-editing">
            AVAILABLE
          </div>
        );
      case 'Created':
        return (
          <div className="onboarding-tag  onboarding-tag-editing">
            CREATED
          </div>
        );
      case 'Editing':
        return (
          <div className="onboarding-tag  onboarding-tag-editing">EDITING</div>
        );
      case 'Draft':
        return (
          <div className="onboarding-tag  onboarding-tag-draft">DRAFT</div>
        );
      case 'Pending':
        return (
          <div className="onboarding-tag  onboarding-tag-draft">PENDING</div>
        );
      case 'Sent':
        return (
          <div className="onboarding-tag  onboarding-tag-editing">SENT</div>
        );
      case 'Error':
        return (
          <div className="onboarding-tag  onboarding-tag-error">ERROR</div>
        );
      case 'Submitted':
        return (
          <div className="onboarding-tag  onboarding-tag-submitted">
            SUBMITTED
          </div>
        );
      case 'Canceled':
        return (
          <div className="onboarding-tag  onboarding-tag-submitted">
            CANCELED
          </div>
        );
      case 'Completed':
        return (
          <div className="onboarding-tag  onboarding-tag-submitted">
            COMPLETED
          </div>
        );
    }
  };

  const isDeleteButtonDisabled = (status) => {
    return ['PENDING', 'CREATED', 'SENT', 'SUBMITTED', 'CANCELED', 'COMPLETED', 'ERROR'].includes(status);
  };

  const isCancelButton = (status) => {
    return ['PENDING', 'CREATED', 'SENT'].includes(status);
  };

  const getAccountName = (value) =>
    accountList?.find((account) => account.id === value)?.name;

  const getDocumentType = (value) =>
    onboardingForms?.find((form) => form.id === value)?.name;

  const columns = [
    {
      title: t('STATUS'),
      dataIndex: 'status_description',
      className: 'status',
      render: (value) => getStatus(value),
      sorter: (a, b) => textSort(a.status_description, b.status_description),
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '',
    },
    {
      title: t('MESSAGES'),
      dataIndex: 'status_message',
      className: 'status',
      render: (value) => value || '- - -',
      sorter: (a, b) => textSort(a.status_message, b.status_message),
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '',
    },
    {
      title: t('PERSON_ORGANIZATION'),
      dataIndex: 'account_id',
      align: 'center',
      className: 'isin table-header-position-center',
      render: (value) => getAccountName(value) ?? '- - -',
      sorter: (a, b) =>
        textSort(
          getAccountName(a.account_id) || '',
          getAccountName(b.account_id) || '',
        ),
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '',
    },
    // {
    //   title: t('PERSONAL_ORGANIZATION_NUMBER'),
    //   dataIndex: 'code',
    //   render: (value) => value || '- - -',
    //   sorter: (a, b) => textSort(a.code, b.code),
    //   sortIcon: (props) => <CustomSortIcon {...props} />,
    //   width: '',
    // },
    {
      title: t('DOCUMENT_TYPE'),
      dataIndex: 'form_id',
      render: (value) => getDocumentType(value) || '- - -',
      sorter: (a, b) =>
        textSort(
          getDocumentType(a.form_id) || '',
          getDocumentType(b.form_id) || '',
        ),
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '',
    },
    {
      title: t('DATE'),
      dataIndex: 'updated_at',
      render: (value) => dayjs(value).format('YYYY-MM-DD HH:mm'),
      sorter: (a, b) => textSort(a.updated_at, b.updated_at),
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '',
    },
    {
      title: t('ACTIONS'),
      align: 'center',
      dataIndex: 'operation',
      className: 'operation',
      width: '',
      render: (_, record) => {
        return (
          <div className="cell-button-wrapper">
            <Tooltip
              placement="top"
              color="white"
              title={
                <span style={{ color: '#000000' }}>{t('VIEW_ADVICE')}</span>
              }
            >
              <Button
                type="text"
                onClick={() => handleView(record.id, record.form_id)}
              >
                <Eye />
              </Button>
            </Tooltip>
            {record?.status_description === 'Completed' && (
              <>
                <Tooltip
                  placement="top"
                  color="white"
                  title={
                    <span style={{ color: '#000000' }}>
                      {t('VIEW_ADVICE_REPORT')}
                    </span>
                  }
                >
                  <Button type="text" onClick={() => handleViewReport(record.id)}>
                    <Report />
                  </Button>
                </Tooltip>
                <Tooltip
                  placement="top"
                  color="white"
                  title={
                    <span style={{ color: '#000000' }}>
                      {t('DOWNLOAD_ADVICE_REPORT')}
                    </span>
                  }
                >
                  <Button type="text" onClick={() => hendleDownload(record.id)}>
                    <Download />
                  </Button>
                </Tooltip>
              </>
            )}
            {record?.status !== 'COMPLETED' && (
              <Tooltip
                placement="top"
                color="white"
                title={
                  <span style={{ color: '#000000' }}>
                    {t(
                      isCancelButton(record?.status)
                        ? 'CANCEL_ONBOARDING'
                        : 'DELETE_ONBOARDING'
                    )}
                  </span>
                }
              >
                <Button
                  type="text"
                  disabled={isDeleteButtonDisabled(record?.status) && !isCancelButton(record?.status)}
                  onClick={() => handleDeleteForm(record.id, record?.status)}
                >
                  {isCancelButton(record?.status) ? (
                    <Cancel />
                  ) : ( 
                    <Delete />
                  )}
                </Button>
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="top-btn-wrapper">
        <Button
          type="text"
          icon={<Pluse />}
          iconPosition="end"
          onClick={handleCreate}
          className="portfolio-details-btn optimise-btn user-btn"
        >
          {t('NEW_ADVICE')}
        </Button>
      </div>
      <Row className="onboarding-search-wrapper">
        <Col className="instrument-button-wraper">
          <CustomSearchInput
            className="account-select-search onboarding"
            placeholder={t('SEARCH_ADVICE')}
            onChange={handleSearch}
          />
          <Button
            className="filter-btn"
            type="default"
            onClick={handeleFilter}
            icon={<Filter />}
            iconPosition="end"
          >
            {t('FILTER')}
          </Button>
        </Col>
      </Row>
      <div
        style={{ padding: '24px' }}
        className="client portfolio-table instrument-table-wrapper"
      >
        <CustomTable
          rowKey={(record) => record.id}
          style={{ width: '100%' }}
          dataSource={filteredIOnboarding}
          columns={columns}
          size="middle"
          loading={loading}
          pagination={false}
        />
      </div>
      {openStart && (
        <ModalOnboarding
          userId={userId}
          openStart={openStart}
          handleClose={handleClose}
          onboardingForms={onboardingForms}
        />
      )}
      {deleteModal && (
        <ModalDeleteOnboarding
          deleteModal={deleteModal}
          setDeleteModal={setDeleteModal}
          userId={userId}
        />
      )}
      {openFilter && (
        <ModalFilterAdvise
          filter={filter}
          openFilter={openFilter}
          handleCloseFilter={handleCloseFilter}
          setFilter={setFilter}
          onboardingForms={onboardingForms}
        />
      )}
      {!!previewData && (
        <OnboardingFileViewer
          open={!!previewData}
          onClose={handleCloseViewReport}
          fileData={previewData?.data}
          mimeType={previewData?.mime_type}
          fileName={previewData?.name}
        />
      )}
    </>
  );
};

export default Onboarding;

Onboarding.propTypes = {
  userId: PropTypes.string,
};
